<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->


<template>
    <v-select
        :value="value"
        :items="projections"
        item-text="name"
        item-value="code"
        persistent-hint
        single-line
        :placeholder="language.t('FormFields.Projection.chooseProjection')"
        @input="$emit('input', $event)"
        dense
    >
        <template
            slot="selection"
            slot-scope="data"
        >{{ data.item.name }}</template>
        <template
            slot="item"
            slot-scope="data"
        >{{ data.item.code }} - {{ data.item.name }}</template>
    </v-select>
</template>

<script>
export default {
    props: ['value'],
    computed: {
        projections: {
            get() {
                if (this.$projections.customer && this.$projections.customer.length > 0) {
                    return this.$projections.customer;
                } else {
                    return this.$projections.all;
                }
            }
        }
    }
}
</script>
